import { render } from "./Button.vue?vue&type=template&id=330cd6ca&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=330cd6ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-330cd6ca"

export default script